"use strict";

var _objectSpread = require("/nfs-data/jenkins-slave/nonlive/workspace/ph_bank_build_package_ihcs_cs-fe-chatbot-chatbotstatic_uat1/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAssembledCommonProps;
var _mergeCollapsedMargins = _interopRequireDefault(require("../helpers/mergeCollapsedMargins"));
var _RenderRegistryProvider = require("../context/RenderRegistryProvider");
var _SharedPropsProvider = require("../context/SharedPropsProvider");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * @internal
 */
function useAssembledCommonProps(_ref, TDefault) {
  var tnode = _ref.tnode,
    propsFromParent = _ref.propsFromParent,
    sharedProps = _ref.sharedProps,
    renderIndex = _ref.renderIndex,
    renderLength = _ref.renderLength,
    TNodeChildrenRenderer = _ref.TNodeChildrenRenderer;
  var _ref2 = (0, _RenderRegistryProvider.useRendererConfig)(tnode),
    Default = _ref2.Default,
    Custom = _ref2.Custom;
  var containerProps = (0, _SharedPropsProvider.useDefaultContainerProps)();
  var assembledProps = _objectSpread({
    tnode: tnode,
    propsFromParent: propsFromParent,
    sharedProps: sharedProps,
    TDefaultRenderer: TDefault,
    TNodeChildrenRenderer: TNodeChildrenRenderer,
    style: (0, _mergeCollapsedMargins.default)(propsFromParent === null || propsFromParent === void 0 ? void 0 : propsFromParent.collapsedMarginTop, tnode.getNativeStyles()),
    type: tnode.type === 'text' || tnode.type === 'phrasing' ? 'text' : 'block',
    propsForChildren: tnode.tagName ? {} : propsFromParent,
    InternalRenderer: Default || TDefault,
    renderIndex: renderIndex,
    renderLength: renderLength
  }, containerProps);
  return {
    assembledProps: assembledProps,
    Renderer: Custom || Default || null
  };
}